// import LayoutPage from "../../Components/LayoutPage";
// import ContainerRight from "./Components/ContainerRight";
// import TradeNotifications from "./Components/TradeNotifications";
// import { useNavigate, useParams } from "react-router-dom";
// import { useEffect, useRef, useState, useMemo } from "react";
// import { type } from "@testing-library/user-event/dist/type";
// import AccountSelect from "./Components/AccountSelect";
// import SymbolSelect from "./Components/SymbolSelect";
// import SetOrder from "./Components/SetOrder";
// import InfoCard from "./Components/InfoCard";
// import Tableau from "./Components/Tableau";
// import TradingView from "./Components/TradingView";
// import OrderList from "./Components/OrderList";
// import Custom from "../../Components/Buttons/Custom";

// export default function Trade() {
//   const symbolOptions = [
//     {
//       value: "BTC/USDT",
//       label: "BTC/USDT",
//       icons: ["btc", "usdt"], // names from your SVG component
//     },
//     {
//       value: "ETH/USDT",
//       label: "ETH/USDT",
//       icons: ["eth", "usdt"],
//     },
//     {
//       value: "BNB/USDT",
//       label: "BNB/USDT",
//       icons: ["bnb", "usdt"],
//     },
//     {
//       value: "XRP/USDT",
//       label: "XRP/USDT",
//       icons: ["xrp", "usdt"],
//     },
//     {
//       value: "SOL/USDT",
//       label: "SOL/USDT",
//       icons: ["sol", "usdt"],
//     },
//   ];

//   const [accountData, setAccountData] = useState(null);
//   const [userData, setUserData] = useState(null);
//   const fetchAccountData = async () => {
//     try {
//       let response = await fetch(
//         `${API_BASE_URL}challenges/trader/accounts`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("access")}`,
//           },
//         },
//       );

//       // 401 → try refresh
//       if (response.status === 401) {
//         try {
//           const refreshResponse = await fetch(
//             `${API_BASE_URL}auth/trader/jwt/refresh/`,
//             {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 refresh: localStorage.getItem("refresh"),
//               }),
//             },
//           );

//           if (!refreshResponse.ok) {
//             // refresh failed → logout and redirect
//             localStorage.removeItem("access");
//             localStorage.removeItem("authCredentials");
//             localStorage.removeItem("refresh");
//             localStorage.removeItem("role");
//             localStorage.removeItem("email");
//             navigate("/signin");
//             return;
//           }

//           const refreshData = await refreshResponse.json();
//           localStorage.setItem("access", refreshData.access);

//           // retry original request with new token
//           response = await fetch(
//             `${API_BASE_URL}challenges/trader/accounts`,
//             {
//               method: "GET",
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${localStorage.getItem("access")}`,
//               },
//             },
//           );
//         } catch (err) {
//           console.error("Error refreshing token:", err);
//           return;
//         }
//       }

//       // final check
//       if (!response.ok) {
//         throw new Error(`https error! Status: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("Account Data:", data);
//       setAccountData(data);
//     } catch (error) {
//       console.error("Error fetching account data:", error);
//     }
//   };
//   const fetchUserData = async () => {
//     try {
//       let response = await fetch(`${API_BASE_URL}auth/trader/info/`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("access")}`,
//         },
//       });

//       // 401 → try refresh
//       if (response.status === 401) {
//         try {
//           const refreshResponse = await fetch(
//             `${API_BASE_URL}auth/trader/jwt/refresh/`,
//             {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 refresh: localStorage.getItem("refresh"),
//               }),
//             },
//           );

//           if (!refreshResponse.ok) {
//             // refresh failed → logout and redirect
//             localStorage.removeItem("access");
//             localStorage.removeItem("authCredentials");
//             localStorage.removeItem("refresh");
//             localStorage.removeItem("role");
//             localStorage.removeItem("email");
//             navigate("/signin");
//             return;
//           }

//           const refreshData = await refreshResponse.json();
//           localStorage.setItem("access", refreshData.access);

//           // retry original request with new token
//           response = await fetch(`${API_BASE_URL}auth/trader/info/`, {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${localStorage.getItem("access")}`,
//             },
//           });
//         } catch (err) {
//           console.error("Error refreshing token:", err);
//           return;
//         }
//       }

//       // final check
//       if (!response.ok) {
//         throw new Error(`https error! Status: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("User Data:", data);
//       setUserData(data);
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchAccountData();
//     fetchUserData();
//   }, []);

//   const [symbol, setSymbol] = useState("btcusdt");

//   const tradingViewMemo = useMemo(() => {
//     return (
//       <TradingView
//         symbol={symbol}
//         className="col-start-7 col-span-10 row-start-1 row-span-3"
//       />
//     );
//   }, [symbol]);

//   const navigate = useNavigate();
//   const { accountId } = useParams();
//   const [tradeData, setTradeData] = useState(null);
//   const [tradeNotifs, setTradeNotifs] = useState([]);
//   const lastEventIdRef = useRef(null);
//   const seenEventIdsRef = useRef(new Set());

//   const lastEventIdStorageKey = (id) => `trade_last_event_id_${id}`;

//   const parseStreamId = (id) => {
//     const [ms, seq] = String(id || "").split("-");
//     const msNum = Number(ms);
//     const seqNum = Number(seq);
//     if (!Number.isFinite(msNum) || !Number.isFinite(seqNum)) return null;
//     return { ms: msNum, seq: seqNum };
//   };

//   const isStreamIdNewer = (candidate, current) => {
//     if (!candidate) return false;
//     if (!current) return true;
//     const a = parseStreamId(candidate);
//     const b = parseStreamId(current);
//     if (!a || !b) return false;
//     if (a.ms !== b.ms) return a.ms > b.ms;
//     return a.seq > b.seq;
//   };

//   const formatNumber = (value, digits = 2) => {
//     const num = Number(value);
//     return Number.isFinite(num) ? num.toFixed(digits) : "-";
//   };

//   const formatSymbol = (value) => (value ? String(value).toUpperCase() : "-");

//   const formatSide = (value) => {
//     if (value === "long" || value === "buy") return "خرید";
//     if (value === "short" || value === "sell") return "فروش";
//     return "نامشخص";
//   };

//   const formatOrderType = (value) => {
//     switch (value) {
//       case "market":
//         return "مارکت";
//       case "limit":
//         return "لیمیت";
//       case "stop_limit":
//         return "استاپ لیمیت";
//       case "stop_market":
//         return "استاپ مارکت";
//       default:
//         return value ? String(value) : "";
//     }
//   };

//   const formatCloseReason = (value) => {
//     switch (value) {
//       case "user":
//         return "بسته‌شدن توسط کاربر";
//       case "manual":
//         return "بسته‌شدن دستی";
//       case "tp":
//         return "حد سود";
//       case "sl":
//         return "حد ضرر";
//       case "liquidation":
//         return "لیکویید";
//       case "violation":
//         return "نقض قوانین";
//       case "autoclose_daily":
//         return "بسته‌شدن روزانه";
//       case "autoclose_weekend":
//         return "بسته‌شدن آخر هفته";
//       case "phase_end":
//         return "پایان فاز";
//       case "system":
//         return "سیستمی";
//       default:
//         return value ? String(value) : "نامشخص";
//     }
//   };

//   const buildEventNotification = (event) => {
//     if (!event) return null;
//     const payload = event.data || {};
//     const symbolLabel = formatSymbol(payload.symbol);
//     const sideLabel = formatSide(payload.side);
//     const orderTypeLabel = formatOrderType(payload.order_type);

//     const formatPriceDetails = () => {
//       const details = [];
//       if (payload.limit_price) {
//         details.push(`لیمیت ${formatNumber(payload.limit_price)}`);
//       }
//       if (payload.stop_price) {
//         details.push(`استاپ ${formatNumber(payload.stop_price)}`);
//       }
//       if (payload.tp) {
//         details.push(`TP ${formatNumber(payload.tp)}`);
//       }
//       if (payload.sl) {
//         details.push(`SL ${formatNumber(payload.sl)}`);
//       }
//       return details.length ? details.join(" / ") : "";
//     };

//     switch (event.event_type) {
//       case "ORDER_PLACED": {
//         const detail = formatPriceDetails();
//         const parts = [
//           `سفارش ثبت شد: ${sideLabel} ${symbolLabel}`,
//           orderTypeLabel ? `(${orderTypeLabel})` : "",
//           detail ? `| ${detail}` : "",
//           payload.margin_usdt
//             ? `| مارجین ${formatNumber(payload.margin_usdt)} USDT`
//             : "",
//         ]
//           .filter(Boolean)
//           .join(" ");
//         return {
//           id: event.id,
//           type: "order_placed",
//           tone: "info",
//           message: parts,
//         };
//       }
//       case "ORDER_UPDATED": {
//         const detail = formatPriceDetails();
//         const parts = [
//           `سفارش بروزرسانی شد: ${sideLabel} ${symbolLabel}`,
//           orderTypeLabel ? `(${orderTypeLabel})` : "",
//           detail ? `| ${detail}` : "",
//           payload.margin_usdt
//             ? `| مارجین ${formatNumber(payload.margin_usdt)} USDT`
//             : "",
//         ]
//           .filter(Boolean)
//           .join(" ");
//         return {
//           id: event.id,
//           type: "order_updated",
//           tone: "info",
//           message: parts,
//         };
//       }
//       case "ORDER_CANCELED": {
//         const parts = [
//           `سفارش لغو شد: ${sideLabel} ${symbolLabel}`,
//           orderTypeLabel ? `(${orderTypeLabel})` : "",
//         ]
//           .filter(Boolean)
//           .join(" ");
//         return {
//           id: event.id,
//           type: "order_canceled",
//           tone: "info",
//           message: parts,
//         };
//       }
//       case "ORDER_FILLED": {
//         const parts = [
//           `سفارش انجام شد: ${sideLabel} ${symbolLabel}`,
//           payload.exec_price
//             ? `| قیمت ${formatNumber(payload.exec_price)}`
//             : "",
//         ]
//           .filter(Boolean)
//           .join(" ");
//         return {
//           id: event.id,
//           type: "order_filled",
//           tone: "info",
//           message: parts,
//         };
//       }
//       case "POSITION_OPENED": {
//         const parts = [
//           `پوزیشن باز شد: ${sideLabel} ${symbolLabel}`,
//           payload.entry_price
//             ? `| ورود ${formatNumber(payload.entry_price)}`
//             : "",
//           payload.qty ? `| حجم ${formatNumber(payload.qty)}` : "",
//         ]
//           .filter(Boolean)
//           .join(" ");
//         return {
//           id: event.id,
//           type: "position_opened",
//           tone: "info",
//           message: parts,
//         };
//       }
//       case "POSITION_TP_SL_UPDATED": {
//         const details = [];
//         if (payload.tp) details.push(`TP ${formatNumber(payload.tp)}`);
//         if (payload.sl) details.push(`SL ${formatNumber(payload.sl)}`);
//         const parts = [
//           `حد سود/ضرر پوزیشن بروزرسانی شد`,
//           details.length ? `| ${details.join(" / ")}` : "",
//         ]
//           .filter(Boolean)
//           .join(" ");
//         return {
//           id: event.id,
//           type: "position_tp_sl_updated",
//           tone: "info",
//           message: parts,
//         };
//       }
//       case "POSITION_CLOSED": {
//         const pnl = Number(payload.realized_pnl_usdt);
//         const tone = Number.isFinite(pnl) && pnl < 0 ? "danger" : "success";
//         const parts = [
//           `پوزیشن بسته شد: ${sideLabel} ${symbolLabel}`,
//           payload.exit_price
//             ? `| خروج ${formatNumber(payload.exit_price)}`
//             : "",
//           Number.isFinite(pnl) ? `| سود/زیان ${formatNumber(pnl)} USDT` : "",
//           payload.reason ? `| علت ${formatCloseReason(payload.reason)}` : "",
//         ]
//           .filter(Boolean)
//           .join(" ");
//         return { id: event.id, type: "position_closed", tone, message: parts };
//       }
//       case "ACCOUNT_VIOLATION": {
//         const parts = [
//           "نقض قوانین حساب",
//           payload.reason ? `| ${formatCloseReason(payload.reason)}` : "",
//           payload.details ? `| ${String(payload.details)}` : "",
//         ]
//           .filter(Boolean)
//           .join(" ");
//         return {
//           id: event.id,
//           type: "account_violation",
//           tone: "danger",
//           message: parts,
//         };
//       }
//       default:
//         return null;
//     }
//   };

//   useEffect(() => {
//     if (!accountId) return;

//     setTradeNotifs([]);
//     let ws = null;
//     let isCancelled = false;

//     const getJwtExpiry = (token) => {
//       try {
//         const base64 = token.split(".")[1];
//         const normalized = base64.replace(/-/g, "+").replace(/_/g, "/");
//         const padded = normalized.padEnd(
//           Math.ceil(normalized.length / 4) * 4,
//           "=",
//         );
//         const payload = JSON.parse(atob(padded));
//         return payload?.exp ? payload.exp * 1000 : null;
//       } catch (err) {
//         return null;
//       }
//     };

//     const isJwtExpired = (token) => {
//       const expiry = getJwtExpiry(token);
//       return !expiry || Date.now() >= expiry;
//     };

//     const logoutAndRedirect = () => {
//       localStorage.removeItem("access");
//       localStorage.removeItem("authCredentials");
//       localStorage.removeItem("refresh");
//       localStorage.removeItem("role");
//       localStorage.removeItem("email");
//       navigate("/signin");
//     };

//     const refreshAccessToken = async () => {
//       try {
//         const refreshToken = localStorage.getItem("refresh");
//         if (!refreshToken) return null;

//         const refreshResponse = await fetch(
//           `${API_BASE_URL}auth/trader/jwt/refresh/`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ refresh: refreshToken }),
//           },
//         );

//         if (!refreshResponse.ok) {
//           logoutAndRedirect();
//           return null;
//         }

//         const refreshData = await refreshResponse.json();
//         localStorage.setItem("access", refreshData.access);
//         return refreshData.access;
//       } catch (err) {
//         console.error("Error refreshing token:", err);
//         return null;
//       }
//     };

//     const getValidAccessToken = async () => {
//       const accessToken = localStorage.getItem("access");
//       if (accessToken && !isJwtExpired(accessToken)) {
//         return accessToken;
//       }
//       return refreshAccessToken();
//     };

//     const buildWsUrl = (token) => {
//       const url = new URL(`trading/${accountId}/`, WS_BASE_URL);
//       const lastEventId = lastEventIdRef.current;
//       if (lastEventId) {
//         url.searchParams.set("last_event_id", lastEventId);
//       }
//       if (token) {
//         url.searchParams.set("token", token);
//       }
//       return url.toString();
//     };

//     const connectWebSocket = async () => {
//       const accessToken = await getValidAccessToken();
//       if (!accessToken || isCancelled) return;

//       lastEventIdRef.current = localStorage.getItem(
//         lastEventIdStorageKey(accountId),
//       );
//       seenEventIdsRef.current = new Set();

//       ws = new WebSocket(buildWsUrl(accessToken));

//       ws.onopen = () => {
//         console.log("WS connected for account:", accountId);
//       };

//       ws.onmessage = (event) => {
//         if (isCancelled) return;
//         try {
//           const data = JSON.parse(event.data);
//           if (
//             data?.type === "trade_events" ||
//             data?.type === "trade_events_backlog"
//           ) {
//             const events = Array.isArray(data.events) ? data.events : [];
//             if (events.length) {
//               const nextNotifs = [];
//               let newestId = lastEventIdRef.current;

//               events.forEach((evt) => {
//                 if (evt?.id && isStreamIdNewer(evt.id, newestId)) {
//                   newestId = evt.id;
//                 }

//                 if (evt?.id && seenEventIdsRef.current.has(evt.id)) {
//                   return;
//                 }

//                 if (evt?.id) {
//                   seenEventIdsRef.current.add(evt.id);
//                 }

//                 const notif = buildEventNotification(evt);
//                 if (notif) nextNotifs.push(notif);
//               });

//               if (
//                 newestId &&
//                 isStreamIdNewer(newestId, lastEventIdRef.current)
//               ) {
//                 lastEventIdRef.current = newestId;
//                 localStorage.setItem(
//                   lastEventIdStorageKey(accountId),
//                   newestId,
//                 );
//               }

//               if (nextNotifs.length) {
//                 setTradeNotifs((prev) => [...prev, ...nextNotifs].slice(-5));
//               }
//             }
//             return;
//           }

//           if (data?.account && data?.market) {
//             setTradeData(data);
//           }
//         } catch (err) {
//           console.error("Invalid WS message:", err);
//         }
//       };

//       ws.onerror = (err) => {
//         console.error("WS error:", err);
//       };

//       ws.onclose = async (event) => {
//         if (isCancelled) return;
//         console.log(
//           "WS closed for account:",
//           accountId,
//           event.code,
//           event.reason,
//         );

//         // 4001/4401 are common auth close codes; refresh and retry once.
//         if (event.code === 4001 || event.code === 4401) {
//           const refreshedToken = await refreshAccessToken();
//           if (refreshedToken && !isCancelled) {
//             connectWebSocket();
//           }
//         }
//       };
//     };

//     connectWebSocket();

//     // ✅ cleanup on unmount / accountId change
//     return () => {
//       isCancelled = true;
//       if (ws) {
//         ws.close();
//       }
//     };
//   }, [accountId]);
//   return (
//     <LayoutPage
//       activeIndex={4}
//       navItems={[]}
//       alwaysMini={true}
//       childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
//     >
//       <TradeNotifications
//         notifications={tradeNotifs}
//         onDismiss={(id) =>
//           setTradeNotifs((prev) => prev.filter((item) => item.id !== id))
//         }
//       />
//       <div className="w-full h-fit grid grid-cols-12 grid-rows-none gap-2.5 min-h-0 overflow-y-auto">
//         <AccountSelect
//           options={accountData ? accountData.live : []}
//           defaultValue={accountId}
//           className="col-start-1 col-span-3"
//         />
//         <SymbolSelect
//           options={symbolOptions}
//           defaultValue="BTC/USDT"
//           name="symbol"
//           setSymbol={setSymbol}
//           className="col-start-1 col-span-3"
//         />
//         <SetOrder
//           tradeData={tradeData}
//           symbol={symbol}
//           className="col-start-1 col-span-3"
//         />
//         <InfoCard tradeData={tradeData} className="col-start-1 col-span-3" />
//         <Custom
//           text="مشاهده جزئیات حساب"
//           href={`/challenge/account/${accountId}/overview`}
//           className="h-fit !rounded-lg !px-5 !py-2.5 text-nowrap text-zi-text-dark bg-zi-gradient-button-blue hocus:ring-1 hocus:ring-inset hocus:ring-offset-1 hocus:ring-zi-border-light hocus:ring-offset-zi-border-dark col-start-1 col-span-3"
//           textShadow={true}
//         />
//         <Tableau
//           tradeData={tradeData}
//           symbol={symbol}
//           className="col-start-4 col-span-3 row-start-1 row-span-3"
//         />
//         {tradingViewMemo}
//         <OrderList
//           tradeData={tradeData}
//           symbol={symbol}
//           className="w-full col-start-4 col-span-9 row-start-4"
//         />
//       </div>
//     </LayoutPage>
//   );
// }
import LayoutPage from "../../Components/LayoutPage";
import ContainerRight from "./Components/ContainerRight";
import TradeNotifications from "./Components/TradeNotifications";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  applyTradeAccountMark,
  findSymbolData,
  formatTradeSymbol,
  getTradeItemSymbol,
  inferSymbolPricePrecision,
  isBlockedTradeSymbol,
  mergeMarketSymbolUpdate,
  normalizeSymbolCode,
  sanitizeMarketSymbols,
  sanitizeTradeAccountSnapshot,
} from "./tradeUtils";
import ContainerAll from "./Components/ContainerAll";
import {
  API_BASE_URL,
  buildWsUrl as buildConfiguredWsUrl,
} from "../../config/api";
import useInfinitePaginated from "../../hooks/useInfinitePaginated";
import { leverageStorageKey, normalizeAllowedLeverages, resolveAccountLeverage, SELECTABLE_LEVERAGE_MODE } from "../../helper/leverage";

const TRADE_SYMBOL_QUERY_KEY = "tradeSymbol";
const LEGACY_SYMBOL_QUERY_KEY = "symbol";
const BITYCLE_SCRIPT_SRC =
  "https://widget.bitycle.com/static/script/v1/script.js";

function toBitycleSymbol(symbol) {
  const normalized = String(symbol || "BTCUSDT")
    .replace(/^[^:]+:/, "")
    .replace("/", "")
    .toUpperCase();

  return `binance_spot:${normalized || "BTCUSDT"}`;
}

function BitycleSnippetChart({ symbol }) {
  const widgetRef = useRef(null);
  const scriptRef = useRef(null);

  useEffect(() => {
    const widgetElement = widgetRef.current;
    if (!widgetElement) return undefined;

    if (scriptRef.current) {
      scriptRef.current.remove();
    }

    widgetElement.innerHTML = "";

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = BITYCLE_SCRIPT_SRC;
    script.async = true;
    script.text = JSON.stringify(
      {
        id: "bitycle-ac-widget",
        theme: "bitycle",
        type: "ac",
        locale: "fa",
        mode: "light",
        style: "tradingview",
        datafeed_type: "general",
        symbol: toBitycleSymbol(symbol),
        source_priority: ["binance_spot"],
        interval: "1D",
        disabled_features: [],
        enabled_features: [],
        calendar_type: "miladi",
        chart_style: "Candle",
      },
      null,
      2,
    );

    script.onerror = () => {
      console.error("Bitycle widget script failed to load");
    };

    widgetElement.after(script);
    scriptRef.current = script;

    return () => {
      script.remove();
      scriptRef.current = null;
      widgetElement.innerHTML = "";
    };
  }, [symbol]);

  return (
    <div className="w-full h-full rounded-2xl overflow-hidden bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div
        id="bitycle-ac-widget"
        ref={widgetRef}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}

export default function Trade() {
  const navigate = useNavigate();
  const { accountId: accountCode } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [accountData, setAccountData] = useState(null);
  const [selectedLeverage, setSelectedLeverage] = useState(null);
  const [marketData, setMarketData] = useState({ symbols: [] });
  const [, setMarketCatalog] = useState([]);
  const { data: marketCatalog, loadingMore: marketCatalogLoadingMore, error: marketCatalogError, hasNext: marketCatalogHasNext, sentinelRef: marketCatalogSentinelRef, scrollRootRef: marketCatalogScrollRootRef, retry: retryMarketCatalog } = useInfinitePaginated({
    endpoint: `${API_BASE_URL}trading/symbols/market`, navigate,
    select: (response) => sanitizeMarketSymbols(response?.results),
  });
  const [symbol, setSymbol] = useState(
    () =>
      normalizeSymbolCode(
        searchParams.get(TRADE_SYMBOL_QUERY_KEY) ??
          searchParams.get(LEGACY_SYMBOL_QUERY_KEY),
      ) || "btcusdt",
  );
  const [tradeNotifs, setTradeNotifs] = useState([]);
  const [selectedSide, setSelectedSide] = useState("buy");
  const [tradeDrawdownData, setTradeDrawdownData] = useState(null);
  const [calculatorInsertRequest, setCalculatorInsertRequest] = useState(null);
  const [marketSocketSession, setMarketSocketSession] = useState(0);
  const lastEventIdRef = useRef(null);
  const seenEventIdsRef = useRef(new Set());
  const marketSocketRef = useRef(null);
  const marketSubscribedSymbolsRef = useRef(new Set());
  const desiredMarketSymbolsRef = useRef([]);
  const syncMarketSubscriptionsRef = useRef(() => {});
  const marketMessageHandlersRef = useRef(new Set());
  const marketSymbols = marketData?.symbols;

  const lastEventIdStorageKey = (id) => `trade_last_event_id_${id}`;

  const parseStreamId = (id) => {
    const [ms, seq] = String(id || "").split("-");
    const msNum = Number(ms);
    const seqNum = Number(seq);
    if (!Number.isFinite(msNum) || !Number.isFinite(seqNum)) return null;
    return { ms: msNum, seq: seqNum };
  };

  const isStreamIdNewer = (candidate, current) => {
    if (!candidate) return false;
    if (!current) return true;
    const a = parseStreamId(candidate);
    const b = parseStreamId(current);
    if (!a || !b) return false;
    if (a.ms !== b.ms) return a.ms > b.ms;
    return a.seq > b.seq;
  };

  const formatNumber = (value, digits = 2) => {
    const num = Number(value);
    return Number.isFinite(num) ? num.toFixed(digits) : "-";
  };

  const formatSymbol = (value) => (value ? String(value).toUpperCase() : "-");

  const formatSide = (value) => {
    if (value === "long" || value === "buy") return "خرید";
    if (value === "short" || value === "sell") return "فروش";
    return "نامشخص";
  };

  const formatOrderType = (value) => {
    switch (value) {
      case "market":
        return "مارکت";
      case "limit":
        return "لیمیت";
      case "stop_limit":
        return "استاپ لیمیت";
      case "stop_market":
        return "استاپ مارکت";
      default:
        return value ? String(value) : "";
    }
  };

  const trimDecimalZerosInText = (value) =>
    String(value).replace(/\b\d+\.\d+\b/g, (match) =>
      match.replace(/\.?0+$/, ""),
    );

  const formatCloseReason = (value) => {
    switch (value) {
      case "user":
        return "بسته‌شدن توسط کاربر";
      case "manual":
        return "بسته‌شدن دستی";
      case "tp":
        return "حد سود";
      case "sl":
        return "حد ضرر";
      case "liquidation":
        return "لیکویید";
      case "violation":
        return "نقض قوانین";
      case "autoclose_daily":
        return "بسته‌شدن روزانه";
      case "autoclose_weekend":
        return "بسته‌شدن آخر هفته";
      case "phase_end":
        return "پایان فاز";
      case "system":
        return "سیستمی";
      default:
        return value ? String(value) : "نامشخص";
    }
  };

  const buildEventNotification = (event) => {
    if (!event) return null;
    const payload = event.data || {};
    if (payload?.symbol && isBlockedTradeSymbol(payload.symbol)) {
      return null;
    }
    const symbolLabel = formatSymbol(payload.symbol);
    const sideLabel = formatSide(payload.side);
    const orderTypeLabel = formatOrderType(payload.order_type);

    const formatPriceDetails = () => {
      const details = [];
      if (payload.limit_price) {
        details.push(`لیمیت ${formatNumber(payload.limit_price)}`);
      }
      if (payload.stop_price) {
        details.push(`استاپ ${formatNumber(payload.stop_price)}`);
      }
      if (payload.tp) {
        details.push(`TP ${formatNumber(payload.tp)}`);
      }
      if (payload.sl) {
        details.push(`SL ${formatNumber(payload.sl)}`);
      }
      return details.length ? details.join(" / ") : "";
    };

    switch (event.event_type) {
      case "ORDER_PLACED": {
        const detail = formatPriceDetails();
        const parts = [
          `سفارش ثبت شد: ${sideLabel} ${symbolLabel}`,
          orderTypeLabel ? `(${orderTypeLabel})` : "",
          detail ? `| ${detail}` : "",
          payload.margin_usdt
            ? `| مارجین ${formatNumber(payload.margin_usdt)} USDT`
            : "",
        ]
          .filter(Boolean)
          .join(" ");
        return {
          id: event.id,
          type: "order_placed",
          tone: "info",
          message: parts,
        };
      }
      case "ORDER_UPDATED": {
        const detail = formatPriceDetails();
        const parts = [
          `سفارش بروزرسانی شد: ${sideLabel} ${symbolLabel}`,
          orderTypeLabel ? `(${orderTypeLabel})` : "",
          detail ? `| ${detail}` : "",
          payload.margin_usdt
            ? `| مارجین ${formatNumber(payload.margin_usdt)} USDT`
            : "",
        ]
          .filter(Boolean)
          .join(" ");
        return {
          id: event.id,
          type: "order_updated",
          tone: "info",
          message: parts,
        };
      }
      case "ORDER_CANCELED": {
        const parts = [
          `سفارش لغو شد: ${sideLabel} ${symbolLabel}`,
          orderTypeLabel ? `(${orderTypeLabel})` : "",
        ]
          .filter(Boolean)
          .join(" ");
        return {
          id: event.id,
          type: "order_canceled",
          tone: "info",
          message: parts,
        };
      }
      case "ORDER_FILLED": {
        const parts = [
          `سفارش انجام شد: ${sideLabel} ${symbolLabel}`,
          payload.exec_price
            ? `| قیمت ${formatNumber(payload.exec_price)}`
            : "",
        ]
          .filter(Boolean)
          .join(" ");
        return {
          id: event.id,
          type: "order_filled",
          tone: "info",
          message: parts,
        };
      }
      case "POSITION_OPENED": {
        const parts = [
          `پوزیشن باز شد: ${sideLabel} ${symbolLabel}`,
          payload.entry_price
            ? `| ورود ${formatNumber(payload.entry_price)}`
            : "",
          payload.qty ? `| حجم ${formatNumber(payload.qty)}` : "",
        ]
          .filter(Boolean)
          .join(" ");
        return {
          id: event.id,
          type: "position_opened",
          tone: "info",
          message: parts,
        };
      }
      case "POSITION_TP_SL_UPDATED": {
        const details = [];
        if (payload.tp) details.push(`TP ${formatNumber(payload.tp)}`);
        if (payload.sl) details.push(`SL ${formatNumber(payload.sl)}`);
        const parts = [
          `حد سود/ضرر پوزیشن بروزرسانی شد`,
          details.length ? `| ${details.join(" / ")}` : "",
        ]
          .filter(Boolean)
          .join(" ");
        return {
          id: event.id,
          type: "position_tp_sl_updated",
          tone: "info",
          message: parts,
        };
      }
      case "POSITION_CLOSED": {
        const pnl = Number(payload.realized_pnl_usdt);
        const tone = Number.isFinite(pnl) && pnl < 0 ? "danger" : "success";
        const parts = [
          `پوزیشن بسته شد: ${sideLabel} ${symbolLabel}`,
          payload.exit_price
            ? `| خروج ${formatNumber(payload.exit_price)}`
            : "",
          Number.isFinite(pnl) ? `| سود/زیان ${formatNumber(pnl)} USDT` : "",
          payload.reason ? `| علت ${formatCloseReason(payload.reason)}` : "",
        ]
          .filter(Boolean)
          .join(" ");
        return { id: event.id, type: "position_closed", tone, message: parts };
      }
      case "ACCOUNT_VIOLATION": {
        const parts = [
          "نقض قوانین حساب",
          payload.reason ? `| ${formatCloseReason(payload.reason)}` : "",
          payload.details ? `| ${trimDecimalZerosInText(payload.details)}` : "",
        ]
          .filter(Boolean)
          .join(" ");
        return {
          id: event.id,
          type: "account_violation",
          tone: "danger",
          message: parts,
        };
      }
      default:
        return null;
    }
  };

  const addClientTradeNotification = (notification) => {
    setTradeNotifs((prev) =>
      [
        ...prev.filter((item) => item.type !== notification.type),
        {
          id: `${notification.type}-${Date.now()}`,
          ...notification,
        },
      ].slice(-5),
    );
  };

  const getJwtExpiry = (token) => {
    try {
      const base64 = token.split(".")[1];
      const normalized = base64.replace(/-/g, "+").replace(/_/g, "/");
      const padded = normalized.padEnd(
        Math.ceil(normalized.length / 4) * 4,
        "=",
      );
      const payload = JSON.parse(atob(padded));
      return payload?.exp ? payload.exp * 1000 : null;
    } catch (err) {
      return null;
    }
  };

  const isJwtExpired = (token) => {
    const expiry = getJwtExpiry(token);
    return !expiry || Date.now() >= expiry;
  };

  const logoutAndRedirect = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("authCredentials");
    localStorage.removeItem("refresh");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    navigate("/signin");
  };

  const refreshAccessToken = async () => {
    try {
      const refreshToken = localStorage.getItem("refresh");
      if (!refreshToken) return null;

      const refreshResponse = await fetch(
        `${API_BASE_URL}auth/trader/jwt/refresh/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ refresh: refreshToken }),
        },
      );

      if (!refreshResponse.ok) {
        logoutAndRedirect();
        return null;
      }

      const refreshData = await refreshResponse.json();
      localStorage.setItem("access", refreshData.access);
      return refreshData.access;
    } catch (err) {
      console.error("Error refreshing token:", err);
      return null;
    }
  };

  const getValidAccessToken = async () => {
    const accessToken = localStorage.getItem("access");
    if (accessToken && !isJwtExpired(accessToken)) {
      return accessToken;
    }
    return refreshAccessToken();
  };

  const fetchWithAuthRefresh = async (url, options = {}) => {
    let accessToken = localStorage.getItem("access");

    if (!accessToken || isJwtExpired(accessToken)) {
      accessToken = await refreshAccessToken();
    }
    if (!accessToken) return null;

    const headers = {
      ...(options.headers || {}),
      Authorization: `Bearer ${accessToken}`,
    };

    let response = await fetch(url, {
      ...options,
      headers,
    });

    if (response.status !== 401) {
      return response;
    }

    accessToken = await refreshAccessToken();
    if (!accessToken) return null;

    return fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${accessToken}`,
      },
    });
  };

  const buildWsUrl = (path, token, queryParams = {}) => {
    const params = { ...queryParams };

    if (token) {
      params.token = token;
    }

    return buildConfiguredWsUrl(path, params);
  };

  const registerMarketSocketHandler = useCallback((handler) => {
    if (typeof handler !== "function") return () => {};

    marketMessageHandlersRef.current.add(handler);

    return () => {
      marketMessageHandlersRef.current.delete(handler);
    };
  }, []);

  const sendMarketSocketMessage = useCallback((payload) => {
    const activeSocket = marketSocketRef.current;
    if (!activeSocket || activeSocket.readyState !== WebSocket.OPEN) {
      return false;
    }

    activeSocket.send(JSON.stringify(payload));
    return true;
  }, []);

  const desiredMarketSymbols = useMemo(() => {
    const normalized = normalizeSymbolCode(symbol);

    if (!normalized || isBlockedTradeSymbol(normalized)) {
      return [];
    }

    return [normalized];
  }, [symbol]);

  useEffect(() => {
    const normalizedSymbol = normalizeSymbolCode(symbol);
    if (!normalizedSymbol) return;

    const currentQuerySymbol = normalizeSymbolCode(
      searchParams.get(TRADE_SYMBOL_QUERY_KEY),
    );
    const hasLegacySymbol = searchParams.has(LEGACY_SYMBOL_QUERY_KEY);

    if (currentQuerySymbol === normalizedSymbol && !hasLegacySymbol) {
      return;
    }

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set(TRADE_SYMBOL_QUERY_KEY, normalizedSymbol);
    nextSearchParams.delete(LEGACY_SYMBOL_QUERY_KEY);
    setSearchParams(nextSearchParams, { replace: true });
  }, [searchParams, setSearchParams, symbol]);

  useEffect(() => {
    desiredMarketSymbolsRef.current = desiredMarketSymbols;
    syncMarketSubscriptionsRef.current();
  }, [desiredMarketSymbols]);

  useEffect(() => {
    setSelectedSide("buy");
    setTradeDrawdownData(null);
    setSelectedLeverage(null);
  }, [accountCode]);

  useEffect(() => {
    const account = accountData?.account;
    if (!account || account.leverage_mode !== SELECTABLE_LEVERAGE_MODE) {
      setSelectedLeverage(null);
      return;
    }
    const allowed = normalizeAllowedLeverages(account.allowed_leverages);
    setSelectedLeverage((current) => {
      if (allowed.includes(Number(current))) return Number(current);
      return allowed[0] ?? null;
    });
  }, [accountCode, accountData?.account]);

  const handleLeverageChange = useCallback((leverage) => {
    const allowed = normalizeAllowedLeverages(accountData?.account?.allowed_leverages);
    if (!allowed.includes(Number(leverage))) return;
    setSelectedLeverage(Number(leverage));
    sessionStorage.setItem(leverageStorageKey(accountCode), String(leverage));
  }, [accountCode, accountData?.account]);

  useEffect(() => {
    const symbolSource = marketCatalog.length ? marketCatalog : marketSymbols;

    if (!Array.isArray(symbolSource) || symbolSource.length === 0) return;

    if (!findSymbolData(symbolSource, symbol)) {
      const fallbackSymbol = normalizeSymbolCode(symbolSource[0]?.symbol);
      if (fallbackSymbol) {
        setSymbol(fallbackSymbol);
      }
    }
  }, [marketCatalog, marketSymbols, symbol]);

  useEffect(() => {
    let ws = null;
    let isCancelled = false;
    let reconnectTimeoutId = null;
    let reconnectAttempts = 0;

    const syncMarketSubscriptions = () => {
      const activeSocket = marketSocketRef.current;
      if (!activeSocket || activeSocket.readyState !== WebSocket.OPEN) return;

      const currentSubscribed = marketSubscribedSymbolsRef.current;
      const desiredSubscribed = new Set(desiredMarketSymbolsRef.current);
      const toSubscribe = desiredMarketSymbolsRef.current.filter(
        (item) => !currentSubscribed.has(item),
      );
      const toUnsubscribe = Array.from(currentSubscribed).filter(
        (item) => !desiredSubscribed.has(item),
      );

      if (toSubscribe.length) {
        activeSocket.send(
          JSON.stringify({
            type: "subscribe",
            symbols: toSubscribe,
          }),
        );
      }

      if (toUnsubscribe.length) {
        activeSocket.send(
          JSON.stringify({
            type: "unsubscribe",
            symbols: toUnsubscribe,
          }),
        );
        setMarketData((prev) => ({
          symbols: Array.isArray(prev?.symbols)
            ? prev.symbols.filter((item) =>
                desiredSubscribed.has(normalizeSymbolCode(item?.symbol)),
              )
            : [],
        }));
      }

      marketSubscribedSymbolsRef.current = desiredSubscribed;
    };

    syncMarketSubscriptionsRef.current = syncMarketSubscriptions;

    const connectMarketSocket = async () => {
      if (isCancelled) return;

      const initialSymbols = desiredMarketSymbolsRef.current.join(",");
      ws = new WebSocket(
        buildWsUrl(
          "/ws/trading/market/",
          null,
          initialSymbols ? { symbols: initialSymbols } : {},
        ),
      );

      marketSocketRef.current = ws;
      marketSubscribedSymbolsRef.current = new Set(
        initialSymbols ? initialSymbols.split(",") : [],
      );

      ws.onopen = () => {
        reconnectAttempts = 0;
        setMarketSocketSession((prev) => prev + 1);
        syncMarketSubscriptions();
      };

      ws.onmessage = (event) => {
        if (isCancelled) return;

        try {
          const data = JSON.parse(event.data);

          marketMessageHandlersRef.current.forEach((handler) => {
            try {
              handler(data);
            } catch (handlerErr) {
              console.error("Market WS handler error:", handlerErr);
            }
          });

          if (data?.type === "market_snapshot") {
            setMarketData({
              symbols: sanitizeMarketSymbols(data.results),
            });
            return;
          }

          if (data?.type === "market_update") {
            setMarketData((prev) => ({
              symbols: mergeMarketSymbolUpdate(prev?.symbols, data),
            }));
          }
        } catch (err) {
          console.error("Invalid market WS message:", err);
        }
      };

      ws.onerror = (err) => {
        console.error("Market WS error:", err);
      };

      ws.onclose = async (event) => {
        if (isCancelled) return;

        console.log("Market WS closed:", {
          code: event.code,
          reason: event.reason,
          wasClean: event.wasClean,
        });

        marketSocketRef.current = null;
        marketSubscribedSymbolsRef.current = new Set();

        if (reconnectTimeoutId || isCancelled) return;
        const baseDelay = 200;
        const maxDelay = 1000;
        const delay = Math.min(maxDelay, baseDelay * 2 ** reconnectAttempts);
        const jitter = Math.floor(Math.random() * 500);
        reconnectAttempts += 1;
        reconnectTimeoutId = setTimeout(() => {
          reconnectTimeoutId = null;
          connectMarketSocket();
        }, delay + jitter);
      };
    };

    connectMarketSocket();

    return () => {
      isCancelled = true;
      syncMarketSubscriptionsRef.current = () => {};
      if (reconnectTimeoutId) {
        clearTimeout(reconnectTimeoutId);
      }
      if (marketSocketRef.current) {
        marketSocketRef.current.close();
      }
      marketSocketRef.current = null;
      marketSubscribedSymbolsRef.current = new Set();
    };
  }, []);

  useEffect(() => {
    if (!accountCode) return;

    setAccountData(null);
    setTradeNotifs([]);
    let ws = null;
    let isCancelled = false;
    let reconnectTimeoutId = null;
    let reconnectAttempts = 0;

    const connectAccountSocket = async () => {
      const accessToken = await getValidAccessToken();
      if (!accessToken || isCancelled) return;

      lastEventIdRef.current = localStorage.getItem(
        lastEventIdStorageKey(accountCode),
      );
      seenEventIdsRef.current = new Set();

      ws = new WebSocket(
        buildWsUrl(`/ws/trading/account/${accountCode}/`, accessToken, {
          last_event_id: lastEventIdRef.current,
        }),
      );

      ws.onopen = () => {
        reconnectAttempts = 0;
      };

      ws.onmessage = (event) => {
        if (isCancelled) return;

        try {
          const data = JSON.parse(event.data);

          if (data?.type === "snapshot") {
            setAccountData(sanitizeTradeAccountSnapshot(data));
            return;
          }

          if (data?.type === "account_mark") {
            setAccountData((prev) => applyTradeAccountMark(prev, data));
            return;
          }

          if (
            data?.type === "trade_events" ||
            data?.type === "trade_events_backlog"
          ) {
            const events = Array.isArray(data.events) ? data.events : [];
            if (!events.length) return;

            const nextNotifs = [];
            let newestId = lastEventIdRef.current;

            events.forEach((evt) => {
              if (evt?.id && isStreamIdNewer(evt.id, newestId)) {
                newestId = evt.id;
              }

              if (evt?.id && seenEventIdsRef.current.has(evt.id)) {
                return;
              }

              if (evt?.id) {
                seenEventIdsRef.current.add(evt.id);
              }

              const notif = buildEventNotification(evt);
              if (notif) nextNotifs.push(notif);
            });

            if (newestId && isStreamIdNewer(newestId, lastEventIdRef.current)) {
              lastEventIdRef.current = newestId;
              localStorage.setItem(
                lastEventIdStorageKey(accountCode),
                newestId,
              );
            }

            if (nextNotifs.length) {
              setTradeNotifs((prev) => [...prev, ...nextNotifs].slice(-5));
            }
          }
        } catch (err) {
          console.error("Invalid account WS message:", err);
        }
      };

      ws.onerror = (err) => {
        console.error("Account WS error:", err);
      };

      ws.onclose = async (event) => {
        if (isCancelled) return;

        if (event.code === 4001 || event.code === 4401) {
          const refreshedToken = await refreshAccessToken();
          if (refreshedToken && !isCancelled) {
            connectAccountSocket();
            return;
          }
        }

        if (reconnectTimeoutId || isCancelled) return;
        const baseDelay = 200;
        const maxDelay = 1000;
        const delay = Math.min(maxDelay, baseDelay * 2 ** reconnectAttempts);
        const jitter = Math.floor(Math.random() * 500);
        reconnectAttempts += 1;
        reconnectTimeoutId = setTimeout(() => {
          reconnectTimeoutId = null;
          connectAccountSocket();
        }, delay + jitter);
      };
    };

    connectAccountSocket();

    return () => {
      isCancelled = true;
      if (reconnectTimeoutId) {
        clearTimeout(reconnectTimeoutId);
      }
      if (ws) {
        ws.close();
      }
    };
  }, [accountCode]);

  const selectedSymbolData = useMemo(() => {
    const symbolSource = marketCatalog.length ? marketCatalog : marketSymbols;
    return findSymbolData(symbolSource, symbol);
  }, [marketCatalog, marketSymbols, symbol]);

  const calculatorTradeContext = useMemo(() => {
    const rawSymbol = getTradeItemSymbol(selectedSymbolData) || symbol;
    const tradeDrawdownLimit = Number(tradeDrawdownData?.trade_drawdown_limit);

    return {
      symbolCode: rawSymbol,
      symbolLabel: formatTradeSymbol(rawSymbol) || "-",
      symbolSvg: selectedSymbolData?.svg ?? "",
      side: selectedSide,
      tradeDrawdownLimit: Number.isFinite(tradeDrawdownLimit)
        ? Math.abs(tradeDrawdownLimit)
        : null,
      freeMargin: accountData?.account?.free_margin ?? null,
      leverage: resolveAccountLeverage(accountData?.account, selectedLeverage),
      maxPriceDecimals: inferSymbolPricePrecision(selectedSymbolData, 4),
    };
  }, [
    accountData,
    selectedLeverage,
    selectedSide,
    selectedSymbolData,
    symbol,
    tradeDrawdownData,
  ]);

  return (
    <LayoutPage
      activeIndex={4}
      navItems={[]}
      alwaysMini={true}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <TradeNotifications
        notifications={tradeNotifs}
        onDismiss={(id) =>
          setTradeNotifs((prev) => prev.filter((item) => item.id !== id))
        }
      />
      <div className="w-full h-fit flex flex-col lg:flex-row gap-5 min-h-0 overflow-y-auto">
        <ContainerAll
          accountData={accountData}
          marketData={marketData}
          symbol={symbol}
          setSymbol={setSymbol}
          calculatorTradeContext={calculatorTradeContext}
          fetchWithAuthRefresh={fetchWithAuthRefresh}
          marketSocketSession={marketSocketSession}
          onCalculatorInsert={(payload) => {
            setCalculatorInsertRequest({
              id: `${Date.now()}-${Math.random()}`,
              ...payload,
            });
          }}
          onTradeNotification={addClientTradeNotification}
          registerMarketSocketHandler={registerMarketSocketHandler}
          sendMarketSocketMessage={sendMarketSocketMessage}
          calculatorInsertRequest={calculatorInsertRequest}
          symbolCatalog={marketCatalog}
          marketCatalogPagination={{ loading: marketCatalogLoadingMore, error: marketCatalogError, hasNext: marketCatalogHasNext, sentinelRef: marketCatalogSentinelRef, scrollRootRef: marketCatalogScrollRootRef, retry: retryMarketCatalog }}
          selectedSide={selectedSide}
          selectedLeverage={selectedLeverage}
          onLeverageChange={handleLeverageChange}
          onSelectedSideChange={setSelectedSide}
          onDrawdownDataChange={setTradeDrawdownData}
          chartElement={<BitycleSnippetChart symbol={symbol} />}
        />
      </div>
    </LayoutPage>
  );
}
